document.addEventListener("DOMContentLoaded", function () {
    let e = document.getElementById("CartFormAgreement"),
        t = document.getElementById("CartFormAgreementBtn"),
        n = document.querySelector(".cart-footer-aggrements-note");
    function c() {
        e.checked ? (t.classList.remove("cart-recap-btn--disabled"), (n.style.display = "none")) : (t.classList.add("cart-recap-btn--disabled"), (n.style.display = "block"));
    }
    e &&
        t &&
        n &&
        (c(),
        e.addEventListener("change", c),
        t.addEventListener("click", (t) => {
            if (e.checked) return null;
            t.preventDefault();
        }));
});
